import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 33,
	height: 32,
	viewBox: "0 0 33 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.6665 28H3.7165M25.6665 24H25.7165M7.6665 24H7.7165M29.6665 28H29.7165M2.6665 20H2.7165M30.6665 20H30.7165M16.6665 25C14.4574 25 12.6665 26.7909 12.6665 29H20.6665C20.6665 26.7909 18.8756 25 16.6665 25ZM16.6665 25L16.6665 21M16.6665 6C15.0097 6 13.6665 7.34315 13.6665 9C13.6665 7.34315 12.3234 6 10.6665 6M16.6665 6C18.3234 6 19.6665 7.34315 19.6665 9C19.6665 7.34315 21.0096 6 22.6665 6M16.6665 6C16.6665 4.34315 15.3234 3 13.6665 3C12.0097 3 10.6665 4.34315 10.6665 6M16.6665 6C16.6665 4.34315 18.0096 3 19.6665 3C21.3234 3 22.6665 4.34315 22.6665 6M22.6665 6C24.3234 6 25.6665 7.34315 25.6665 9M7.6665 9C7.6665 7.34315 9.00965 6 10.6665 6M16.6665 21C22.7416 21 27.6665 16.0751 27.6665 10L5.6665 10C5.6665 16.0751 10.5914 21 16.6665 21Z",
		stroke: "#FFC014",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSuccess;
